import { useEffect, type ReactNode } from "react";
import { Link } from "react-router";

interface PageHeaderProps {
  title: string;
  description?: ReactNode;
  actions?: ReactNode;
  back?: { to: string; label: string };
}

/** Page title (h1) + document.title, so every route announces itself. */
export function PageHeader({ title, description, actions, back }: PageHeaderProps) {
  useEffect(() => {
    document.title = `${title} · VADS`;
  }, [title]);
  return (
    <header className="page-header">
      <div>
        {back ? (
          <nav className="breadcrumbs" aria-label="Breadcrumb">
            <Link to={back.to}>← {back.label}</Link>
          </nav>
        ) : null}
        <h1>{title}</h1>
        {description ? <p className="page-header-desc">{description}</p> : null}
      </div>
      {actions ? <div className="row">{actions}</div> : null}
    </header>
  );
}
